import {useState,useEffect,useContext, ChangeEvent} from 'react';
import{Formik, Form, Field,ErrorMessage, FormikErrors} from 'formik';
import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, IconButton, FormHelperText, Grid, Modal, Tabs, Tab } from '@mui/material';
import { Modal as ModalStrap, ModalHeader, ModalBody,TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import * as Yup from 'yup';
import { TipoProductoDTO } from '../../interfaces/TipoProductoDTO';
import CatalogService from '../../services/CatalogService';
import ProductoService from '../../services/ProductoService';
import AlertService from '../../services/AlertService';
import { useNavigate, useParams } from 'react-router-dom';
import { RiSave3Fill } from 'react-icons/ri';
import {MdAssignmentReturn} from 'react-icons/md';
import {BiAddToQueue} from 'react-icons/bi';
import {AiFillCaretLeft} from 'react-icons/ai';
import Stack from '@mui/material/Stack';
import { AiOutlineUserAdd, AiFillDelete, AiOutlinePlusCircle,AiOutlineSearch } from 'react-icons/ai';
import {FaRegAddressCard} from 'react-icons/fa'
import {format} from 'date-fns';
import { ObjetoLabel, ObjetoLabelFilter } from '../../interfaces/ObjetoLabel';
import { IndexacionDTO } from '../../interfaces/IndexacionDTO';
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from '../../interfaces/ProductoTerminadoDTO';
import { CasUserContext } from '../../services/casUserContext';
import { TblProductoProdTermin, setProductoTerminado } from '../../interfaces/TblProductoProdTermin';
import { TblDecInvMotivoProdTermin, setProductoMotivo } from '../../interfaces/TblDecInvMotivoProdTermin';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { Card,CardBody,CardHeader } from 'reactstrap';
import { ProductoColaboradorDTO, setListProductoColaborador } from '../../interfaces/ColaboradorProdcutoDTO';
import { CatagNumberDTO } from '../../interfaces/CatalogoDTO';
import { Unidad } from '../../interfaces/Unidad';
import {Card as CardUI, CardActions, CardContent} from '@mui/material';
import Typography from '@mui/material/Typography';
import ProyectoService from '../../services/ProyectoService';
import { ProyectoColaboradoreDTO } from '../../interfaces/ProyectoColaboradoreDTO';
import { FileModel, setFileModelWithName } from '../../interfaces/FileModel';
import { ProductoTerminadoObjOdDTO, setProductoTerminadoObjOdDTO } from '../../interfaces/ProductoTerminadoObjOdDTO';
import { ODS } from '../../interfaces/ODS';
//tener cuidado con la importacion
import '../../services/utils';
import { ProductoAreaConocimientoDTO, setProductoAreaConocimientoDTO } from '../../interfaces/ProductoAreaConocimientoDTO';
import { ProductoLineaInvestigacionDTO, setProductoLineaInvestigacionDTO } from '../../interfaces/ProductoLineaInvestigacionDTO';
import Swal from 'sweetalert2';
import { convertirFormatoFecha } from '../../services/utils';

interface Props{
    idProducto: number
    idProyecto: number
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const catalogService = new CatalogService();
const productoService = new ProductoService();
const proyectoService = new ProyectoService();
const alertaService = new AlertService();

const filaSchema = Yup.object().shape({
    cedula: Yup.string().required('La cedula es requerida').matches(/^\d{10}$/, 'La cédula debe tener 10 dígitos'),
    nombre: Yup.string().required('Nombres son requeridos'),
    institucion: Yup.string().required('Institución es requerida'),
    email: Yup.string().email('Correo no válido').required('Correo es requerido'),
    tipoparticipacion: Yup.string().notOneOf(['0'],'No puede ser ninguno').required('Rol es requerido'),
    idunidad: Yup.string().notOneOf([''],'No puede ser ninguno').required('Rol es requerido'),
    tipocolaborador: Yup.string().notOneOf(['0'],'No puede ser ninguno').required('Rol es requerido'),
    // Otras reglas de validación para otros campos de la fila
});

const validationSchema = Yup.object().shape({
    idproyecto: Yup.string().test('requiredIfProyecto', 'Se debe seleccionar un proyecto', function(value) {
        const tiene = this.parent.tieneProyecto;
        const idpro = this.parent.idproyecto;
        if (tiene === 'S') {
          return idpro > 0;
        }
        return true;
    }),
    tipomotivo: Yup.string().notOneOf(['0'],'No puede ser ninguno'),
    motivo: Yup.string().test('requiredIfmotivo', 'La explicación no puede quedar en blanco.', function(value) {
        const tiene = this.parent.tieneProyecto;
        const motivo: string = this.parent.motivo;
        if (tiene === 'N') {
          return  motivo !== undefined && motivo.length > 0;
        }
        return true;
    }),
    titulo: Yup.string().required('El titulo es requerido.'),
    tipo: Yup.number().required('Se debe seleccionar tipo').positive('Debe escoger un Tipo de Producto'),
    anio: Yup.number().test('anioRequired', 'El campo es requerido', function (value) {
        const tipo = this.parent.tipo;
        if ([24,25,26,27].includes(tipo)) {
          return value !== undefined ? value > 0 : false; // Verifica que value no sea undefined antes de validar
        }
        return true; // No se aplica la validación en otros casos
    }),
    url: Yup.string().test('requiredIfTipo', 'El URL de la publicación es requerido.', function(value) {
        const tipo = this.parent.tipo;
        if ([24,25,26,27].includes(tipo)) {
          return !!value;
        }
        return true;
    }),
    //doi: Yup.string().required('El DOI es requerido.'),
    doi: Yup.string().test('requiredIfTipo', 'El URL de la publicación es requerido.', function(value) {
        const tipo = this.parent.tipo;
        if ([24,25,26,27].includes(tipo)) {
          return !!value;
        }
        return true;
    }),
    fechapublicacion: Yup.string().test('requiredIfTipo', 'La fecha es requerido', function(value) {
        const tipo = this.parent.tipo;
        if ([24,25,26,27].includes(tipo)) {
          return !!value;
        }
        return true;
    }),
    bdrevista: Yup.number().test('requiredIfTipo', 'Campo requerido', function(value) {
        const tipo = this.parent.tipo;
        if ([24,25].includes(tipo)) {
          return !!value;
        }
        return true;
    }),
    colaboradores: Yup.array().test('ifColaboradores','Debe llenar todos los campos correctamente.', function(value){
        if (value && value.length > 0) {
            // Si hay colaboradores, validar cada uno individualmente
            const isValid = value.every((colaborador) => filaSchema.isValidSync(colaborador));
            return isValid;
          }
          // Si no hay colaboradores, no se aplica esta validación
          return true
    })
    .test('ifInterno', 'Si el colaborador es interno, debe indicar la unidad o centro.', function (value) {
        if (value && value.length > 0) {
          // Si hay colaboradores, validar cada uno individualmente
          const isValid = value.every((colaborador) => {
            // Aplicar tus condiciones específicas aquí
            //console.log('tipocol',colaborador.tipocolaborador);
            //console.log('idunidad',colaborador.idunidad);
            if(colaborador.tipocolaborador === 1){
                return colaborador.tipocolaborador === 1 && colaborador.idunidad > 0;
            }
            return true;            
          });
          return isValid;
        }
        // Si no hay colaboradores, no se aplica esta validación
        return true;
    })
    .test('min-length', 'Debe haber al menos un colaborador en la lista', function (value) {
      return value && value.length > 0;
    }),
});

const styleModal = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const cardHeaderStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};

const tabStyle = {
    cursor: 'pointer', // Cambia el cursor a "pointer" cuando se pasa sobre el botón
  };

const buttonStyle = {
    marginTop: '10px', // Ajusta el valor de acuerdo a tu preferencia
  };

export default function FormProducto() {
    let history = useNavigate()
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    const idusuariocrea = casUserContext.userData.idpersona;
    const idpersona = casUserContext.userData.idpersona;
    const [ready,setReady] = useState(false);
    const {idProducto} = useParams();  
    const [datosFormulario,setDatosFormulario] = useState<ProductoTerminadoDTO>(()=> getVoidProdcutoTerminadoDTO());
        
    //Seccion Variables
    const anioActual:number = new Date().getFullYear();
    const [tipoProductos,setTipoProductos] = useState<Array<TipoProductoDTO>>([])
    const [anios,setAnios] = useState<Array<number>>([])
    const [desicion,setDesicion] = useState<Array<ObjetoLabel>>([])
    const [tieneproy,setTieneproy] = useState<Array<ObjetoLabel>>([])
    const [unidades,setUnidades] = useState<Array<Unidad>>([])
    const [misProyectos,setMisProyectos] = useState<Array<CatagNumberDTO>>([])
    const [quartil,setQuartil] = useState<Array<ObjetoLabel>>([])
    const [motivos,setMotivos] = useState<Array<ObjetoLabel>>([])
    const [listIndex,setListIndex] = useState<Array<IndexacionDTO>>([])
    const [listRolColaborador,setListRolColaborador] = useState<Array<ObjetoLabelFilter>>([])
    const [estadoEquipo,setEstadoEquipo] = useState<Array<ObjetoLabelFilter>>([])
    const [frecuencia,setFrecuencia] = useState<Array<ObjetoLabelFilter>>([])
    const [tipoColaborador,setTipoColaborador] = useState<Array<ObjetoLabelFilter>>([])
    const [colaboradorProyecto, setColaboradorProyecto] = useState<Array<ProyectoColaboradoreDTO>>([])
    const [busquedaUsuario, setBusquedaUsuario] = useState<Array<ProyectoColaboradoreDTO>>([])
    const [open, setOpen] = useState(false);
    const [userModal,setUserModal] = useState(false);
    const [loadingModal,setLoadingModal] = useState(false);
    const [listODS,setListODS] = useState<Array<CatagNumberDTO>>([]);
    const [areasLineasInvestigacion,setAreasLineasInvestigacion] = useState<Array<CatagNumberDTO>>([]);
    const [areasCine,setAreasCine] = useState<Array<CatagNumberDTO>>([]);
    const [subAreasCine,setSubAreasCine] = useState<Array<CatagNumberDTO>>([]);
    const [subAreasCineDet,setSubAreasCineDet] = useState<Array<CatagNumberDTO>>([]);
    const [tap, setTap] = useState(0);
    const [mailBusqueda, setMailBusqueda] = useState('');
    const [apellidosBusqueda, setApellidosBusqueda] = useState('');
    const [listRol,setListRol] = useState<Array<ObjetoLabelFilter>>([
        {
            "id": 1,
            "label": "AUTOR",
            "visibilidad": "S"
        },
        {
            "id": 2,
            "label": "CO-AUTOR",
            "visibilidad": "S"
        },
        {
            "id": 3,
            "label": "EDITOR",
            "visibilidad": "N"
        },
        {
            "id": 4,
            "label": "RELATOR",
            "visibilidad": "N"
        },
        {
            "id": 5,
            "label": "COMPILADOR",
            "visibilidad": "N"
        },
        {
            "id": 6,
            "label": "INVENTOR",
            "visibilidad": "INV"
        }
    ]);
       
    //Seccion Funciones
    const handleTap = (event: React.SyntheticEvent, newValue: number) => {
        setTap(newValue);
    };
    function CustomTabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
              </Box>
            )}
          </div>
        );
      }
    function listRolAjust(id:number){
        //INV -> Inventores
        //El set no responde bien al momento de editar
        //setListRol(catalogService.getRolColaboradorProducto)
        //console.log(listRol);
        switch(id){
            case 32:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad==='INV')));
                break;
            case 34:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad==='INV')));
                break;
            default:
                setListRolColaborador(listRol.filter(x => x.visibilidad === 'S'));
                break;
        }
    }
    const handleOpenModal = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);
    const toggleOpen = () => {
        setOpen(!open);
    };
    const handleOpenUserModal = () => setUserModal(true);
    const handleCloseUserModal = () => setUserModal(false);
    const toggleModal = () => {
        setUserModal(!userModal);
    };
    const goToNavigation = (site:string) =>{
        history(site)
    }
    function setListColaboradores(idproyecto:number){
        proyectoService.GetColaboradoresProyectoById(idproyecto,token)
            .then((data) => {
                //console.log(data.objDatos);
                setColaboradorProyecto(data.listData);
            })               
            .catch((error) => console.error(error));
    }
    function setListBusqueda(apellidos: string,email:string){
        setLoadingModal(true);
        proyectoService.GetDatosPersonalesColaborador(apellidos,email,token)
            .then((data) => {
                //console.log(data.objDatos);
                if(data.listData === null){
                    setBusquedaUsuario([]);
                    setLoadingModal(false); 
                }else{
                    setBusquedaUsuario(data.listData);
                    setLoadingModal(false); 
                }                
            })               
            .catch((error) => {
                console.error(error)
                setBusquedaUsuario([]);
                setLoadingModal(false); 
            });           
    }
    const handleEmailBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        //console.log(value);
        setMailBusqueda(value);        
    }
    const handleEmailBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        // Acciones a realizar cuando el campo de entrada pierde el foco
        //console.log('Campo perdió el foco. Valor actual:', mailBusqueda);
    };
    const handleApellidosBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Actualizar el estado
        if (value !== apellidosBusqueda) {
            setApellidosBusqueda(value);
        }       
    }
    function setProducto(data: any) {
        //console.log(data.objDatos.producto);
        //console.log(data.objDatos.colProducto);
        //console.log(casUserContext.userData.idinv);
        //console.log(listRol);
        //console.log(data.objDatos);
        setDatosFormulario({
            ...datosFormulario,
            producto: setProductoTerminado(data.objDatos.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.objDatos.motivo) as TblDecInvMotivoProdTermin,
            areaConocimiento: setProductoAreaConocimientoDTO(data.objDatos.areaConocimiento) as ProductoAreaConocimientoDTO,
            lineaInvestigacion: setProductoLineaInvestigacionDTO(data.objDatos.lineaInvestigacion) as ProductoLineaInvestigacionDTO,
            ods: setProductoTerminadoObjOdDTO(data.objDatos.ods) as ProductoTerminadoObjOdDTO,
            colProducto: setListProductoColaborador(data.objDatos.colProducto) as Array<ProductoColaboradorDTO>,            
            //adjuntos: setListFileModel(data.objDatos.adjuntos) as Array<FileModel>,
            idpersona: idpersona,
            idCategoriaProducto: data.idCategoriaProducto as number,
        });
        setListSubaArea(data.objDatos.areaConocimiento.codarea);
        setListSubaAreaDet(data.objDatos.areaConocimiento.codsubarea);
        listRolAjust(data.objDatos.producto.iddecinvtipoproductoesperado);
        setReady(true);
    }
    function usoParticipacion(id:number):boolean{
        let flat = false;
        if([32,34].includes(id)){
            flat = true;
        }
        return flat;
    }
    function FormTitleColHandle(id:number): string{
        let flat = '';
        if([33,35,36,43].includes(id)){
            flat = 'Autores';
        }else if([32].includes(id)){
            flat = 'Inventores/diseñadores';
        }
        else if([34].includes(id)){
            flat = 'Inventores u Obtentores';
        }else if([44].includes(id)){
            flat = 'Inventores';
        }
        else if([37].includes(id)){
            flat = 'Custodio';
        }else if([38].includes(id)){
            flat = 'Responsable';
        }else if([39,40].includes(id)){
            flat = 'Organizadores';
        }else{
            flat = 'Colaboradores';
        }
        return flat;
    }
    function FormTypeHandle(id:number,name: string): boolean{
        let flat = true;
        switch(id){
            case 7://Libro/Capitulo de libro ANTIGUO
                let campos7 = ['anio','fechapublicacion','editorial','volumen','paginas','url','bdrevista','codISSN','doi','revisionpares'];
                flat = campos7.includes(name);
                break;
            case 17://Infraestructura/Laboratorio antiguo
                let campos17 = ['idunidad','tipolab','nevento','levento','resumen'];
                flat = campos17.includes(name);
                break;
            case 12://Infraestructura/Equipamento antiguo
                let campos12 = ['idunidad','levento','fevento','marca','modelo','serie','fechapublicacion','fevento','inventario','estado','isindex','frecuencia','asistObjetiv','especificacion'];
                flat = campos12.includes(name);
                break;
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                let campos = ['anio','url','doi','fechapublicacion','bdrevista','nombreRevista','codISSN','urlRevista','impactoIndex','impactoSJR','cuartil','volumen','paginas','palabrasClave','resumen','lineainvestigacion','codarea','codsubarea','codsubareadetallada','adjunto','adjunto2','adjunto3'];
                flat = campos.includes(name);
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                let campos26 = ['anio','url','doi','fechapublicacion','bdrevista','nombreRevista','codISSN','urlRevista','impactoIndex','impactoSJR','cuartil','volumen','paginas','palabrasClave','resumen','lineainvestigacion','codarea','codsubarea','codsubareadetallada','adjunto','adjunto2','adjunto3'];
                flat = campos26.includes(name);
                break;
            case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
                let campos25 = ['anio','url','doi','fechapublicacion','nombreRevista','codISSN','revisionpares','volumen','paginas','palabrasClave','resumen','adjunto','adjunto2'];
                flat = campos25.includes(name);
                break;
            case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
                let campos27 = ['anio','url','doi','fechapublicacion','nombreRevista','codISSN','palabrasClave','resumen','adjunto'];
                flat = campos27.includes(name);
                break;
            case 28://Libro/Capitulo de libro
                let campos28 = ['anio','fechapublicacion','editorial','volumen','paginas','url','bdrevista','codISSN','doi','revisionpares','adjunto','adjunto2','adjunto3'];
                flat = campos28.includes(name);
                break;
            case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
                let campos29 = ['url','fevento','palabrasClave','resumen','adjunto','adjunto2'];
                flat = campos29.includes(name);
                break;
            case 30://TESIS DE DOCTORADO
                let campos30 = ['url','fevento','palabrasClave','resumen','adjunto','adjunto2'];
                flat = campos30.includes(name);
                break;
            case 31://ABSTRACT CONFERENCIA
                let campos31 = ['url','nombreRevista','codISSN','nevento','levento','fevento','palabrasClave','adjunto','adjunto2'];
                flat = campos31.includes(name);
                break;
            case 32://Solicitud de Patente
                let campos32 = ['iddecinvobjods','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','resumen','palabrasClave','adjunto','adjunto2','adjunto3','adjunto4', 'adjunto5'];
                flat = campos32.includes(name);
                break;
            case 33://Derecho de Autor
                let campos33 = ['iddecinvobjods','fevento','especificacion','adjunto','adjunto2'];
                flat = campos33.includes(name);
                break;
            case 34://NUEVA OBTENCION VEGETAL
                let campos34 = ['iddecinvobjods','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','resumen','palabrasClave','adjunto','adjunto2'];
                flat = campos34.includes(name);
                break;
            case 35://CASO ESTUDIO
                let campos35 = ['url','asistObjetiv','innovaVerific','logrosSistemac','especificacion','retosComunic','adjunto','adjunto2'];
                flat = campos35.includes(name);
                break;
            case 36://POSTER CONFERENCIA
                let campos36 = ['nombreRevista','nevento','levento','fevento','adjunto','adjunto2'];
                flat = campos36.includes(name);
                break;
            case 37://Infraestructura/Equipamento
                let campos37 = ['idunidad','levento','marca','modelo','serie','fechapublicacion','fevento','inventario','estado','isindex','frecuencia','asistObjetiv','especificacion','adjunto'];
                flat = campos37.includes(name);
                break;
            case 38://Infraestructura/Laboratorio
                let campos38 = ['idunidad','tipolab','nevento','levento','resumen','adjunto'];
                flat = campos38.includes(name);
                break;
            case 39://Organización y ejecución de Taller/Curso/Conferencia
                let campos39 = ['nevento','levento','fevento','adjunto','adjunto2','adjunto3'];
                flat = campos39.includes(name);
                break;    
            case 40://Metodología/Protocolo implementado
                let campos40 = ['codigoproducto','especificacion','adjunto','adjunto2','adjunto3','adjunto4'];
                flat = campos40.includes(name);
                break;
            case 41://Proyecto de titulación de maestría profesional
                let campos41 = ['url','palabrasClave','resumen','fevento','adjunto','adjunto2'];
                flat = campos41.includes(name);
                break;
            case 42://Proyecto de titulación de maestría profesional
                let campos42 = ['url','palabrasClave','resumen','fevento','adjunto','adjunto2'];
                flat = campos42.includes(name);
                break;
            case 43://Participación en conferencia (sin artículo)
                let campos43 = ['nombreRevista','nevento','levento','fevento','adjunto'];
                flat = campos43.includes(name);
                break;
            case 44://Secreto Empresarial o información no divulgada
                let campos44 = ['iddecinvobjods','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','fevento','adjunto','adjunto2'];
                flat = campos44.includes(name);
                break;
            default:
                flat = false;
                break;
        }
        return flat;
    }
    function FormLabelHandle(id:number,name: string): string{
        let label = "";
        switch(id){
            case 0:
                switch(name){
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    default:
                        label = name;
                        break;
                }                
            break;
            case 17://Infraestructura/Laboratorio antiguo
                switch(name){
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Ubicación: '
                        break;
                    case 'tipolab':
                        label = 'Tipo de Laboratorio: '
                        break;                         
                    case 'palabrasClave':
                            label = 'Responsable: '
                            break;
                    case 'resumen':
                        label = 'Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 12://Infraestructura/Equipamento antiguo
                switch(name){
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Ubicación: '
                        break;
                    case 'fevento':
                        label = 'Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                        break;
                    case 'marca':
                        label = 'Marca: '
                        break;
                    case 'modelo':
                        label = 'Modelo: '
                        break;
                    case 'serie':
                        label = 'Número de Serie (ID): '
                        break;
                    case 'invetario':
                        label = 'Número Inventario de ESPOL/ESPOLTECH: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha de Compra - Obligatorio solo si escoge la opción de "NUEVO": '
                        break;
                    case 'palabrasClave':
                            label = 'Responsable: '
                            break;
                    case 'resumen':
                        label = 'Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'isindex':
                        label = 'Condiciones de Brindar Servicio: '
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                switch(name){
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                } 
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                switch(name){
                    case 'adjunto':
                        label = '*Área de conocimiento CINE/UNESCO';
                        break;
                    case 'adjunto2':
                        label = '*Sub-área detallada de conocimiento CINE/UNESCO';
                        break;
                    case 'adjunto3':
                        label = '*Línea de investigación y vinculación';
                        break;
                    case 'codISSN':
                            label = 'Código ISSN de la Revista: '
                            break;
                    case 'nevento':
                            label = 'Nombre Evento: '
                            break;
                    case 'levento':
                            label = 'Lugar Evento: '
                            break;
                    case 'fevento':
                            label = 'Fecha Evento: '
                            break;                        
                    case 'palabrasClave':
                            label = 'Palabras Claves: '
                            break;
                    case 'resumen':
                            label = 'Resumen: '
                            break;
                    case 'idunidad':
                            label = 'Unidad: '
                            break;
                    case 'tipolab':
                            label = 'Tipo Laboratorio: '
                            break;
                    case 'fechapublicacion':
                            label = 'Fecha Publicación: '
                            break;
                    case 'editorial':
                            label = 'Editorial: '
                            break;
                    case 'nombreRevista':
                            label = 'Nombre de Revista/ Memoria de Evento: '
                            break;
                    case 'url':
                            label = 'Url de Publicación: '
                            break;
                    case 'especificacion':
                            label = 'Especificación: '
                            break;
                    case 'iddecinvobjods':
                            label = 'ODS del producto: '
                            break;
                    case 'codarea':
                            label = 'Área CINE/UNESCO: '
                            break;
                    case 'codsubarea':
                            label = 'Sub-área detallada CINE/UNESCO: '
                            break;
                    case 'codsubareadetallada':
                            label = 'Sub-área detallada CINE/UNESCO: '
                            break;
                    case 'anio':
                            label = 'Año de Publicación: ';
                            break;
                    case 'iddecinvareaconocimiento':
                            label = 'Área de investigación: ';
                            break;
                    case 'lineainvestigacion':
                            label = 'Línea de investigación: ';
                            break;
                    default:
                        label = name;
                        break;
                }
            break;
            case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
                switch(name){
                    case 'adjunto':
                        label='*Adjuntar PDF del Artículo científico';
                        break;
                    case 'adjunto2':
                        label='Adjuntar Prueba de Revisión de Pares - Obligatorio si tuvo revisión por pares';
                        break;
                        case 'codISSN':
                            label = 'Código ISSN de la Revista: '
                            break;
                    case 'nevento':
                            label = 'Nombre Evento: '
                            break;
                    case 'levento':
                            label = 'Lugar Evento: '
                            break;
                    case 'fevento':
                            label = 'Fecha Evento: '
                            break;                        
                    case 'palabrasClave':
                            label = 'Palabras Claves: '
                            break;
                    case 'resumen':
                            label = 'Resumen: '
                            break;
                    case 'idunidad':
                            label = 'Unidad: '
                            break;
                    case 'tipolab':
                            label = 'Tipo Laboratorio: '
                            break;
                    case 'fechapublicacion':
                            label = 'Fecha Publicación: '
                            break;
                    case 'editorial':
                            label = 'Editorial: '
                            break;
                    case 'nombreRevista':
                            label = 'Nombre de Revista/ Memoria de Evento: '
                            break;
                    case 'url':
                            label = 'Url de Publicación: '
                            break;
                    case 'especificacion':
                            label = 'Especificación: '
                            break;
                    case 'iddecinvobjods':
                            label = 'ODS del producto: '
                            break;
                    case 'codarea':
                            label = 'Área CINE/UNESCO: '
                            break;
                    case 'codsubarea':
                            label = 'Sub-área detallada CINE/UNESCO: '
                            break;
                    case 'codsubareadetallada':
                            label = 'Sub-área detallada CINE/UNESCO: '
                            break;
                    case 'anio':
                            label = 'Año de Publicación: ';
                            break;
                    case 'iddecinvareaconocimiento':
                            label = 'Área de investigación: ';
                            break;
                    case 'lineainvestigacion':
                            label = 'Línea de investigación: ';
                            break;  
                    default:
                        label = name;
                        break;
                }

            break;
            case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
                switch(name){
                    case 'adjunto':
                        label='*Adjuntar PDF del Artículo de divulgación científica';
                        break;
                    case 'codISSN':
                            label = 'Código ISSN de la Revista: '
                            break;
                    case 'nevento':
                            label = 'Nombre Evento: '
                            break;
                    case 'levento':
                            label = 'Lugar Evento: '
                            break;
                    case 'fevento':
                            label = 'Fecha Evento: '
                            break;                        
                    case 'palabrasClave':
                            label = 'Palabras Claves: '
                            break;
                    case 'resumen':
                            label = 'Resumen: '
                            break;
                    case 'idunidad':
                            label = 'Unidad: '
                            break;
                    case 'tipolab':
                            label = 'Tipo Laboratorio: '
                            break;
                    case 'fechapublicacion':
                            label = 'Fecha Publicación: '
                            break;
                    case 'editorial':
                            label = 'Editorial: '
                            break;
                    case 'nombreRevista':
                            label = 'Nombre de Revista/ Memoria de Evento: '
                            break;
                    case 'url':
                            label = 'Url de Publicación: '
                            break;
                    case 'especificacion':
                            label = 'Especificación: '
                            break;
                    case 'iddecinvobjods':
                            label = 'ODS del producto: '
                            break;
                    case 'codarea':
                            label = 'Área CINE/UNESCO: '
                            break;
                    case 'codsubarea':
                            label = 'Sub-área detallada CINE/UNESCO: '
                            break;
                    case 'codsubareadetallada':
                            label = 'Sub-área detallada CINE/UNESCO: '
                            break;
                    case 'anio':
                            label = 'Año de Publicación: ';
                            break;
                    case 'iddecinvareaconocimiento':
                            label = 'Área de investigación: ';
                            break;
                    case 'lineainvestigacion':
                            label = 'Línea de investigación: ';
                            break;
                    default:
                        label=name;
                        break;
                }
            break;
            case 28://Libro/Capitulo de libro
                switch(name){
                    case 'adjunto':
                        label = '*Adjuntar PDF del libro o capítulo de libro';
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar Notificación de Aceptación(En caso de que exista)';
                        break;
                    case 'adjunto3':
                        label = '*Adjuntar Prueba de Revisión de Pares - Obligatorio si se coloca SI en revisión por pares';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    default:
                        label=name;
                        break;
                }
            break;
            case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
                switch(name){
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'fevento':
                        label = 'Fecha de titulación: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 30://TESIS DE DOCTORADO
                switch(name){
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'fevento':
                        label = 'Fecha de titulación: '
                        break;
                    case 'palabrasClave':
                            label = 'Palabras claves: '
                            break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 31://ABSTRACT CONFERENCIA
                switch(name){
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'codISSN':
                        label = 'Código ISSN / ISBN de las memorias de conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'palabrasClave':
                            label = 'Palabras claves: '
                            break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar el Abstract presentado en la conferencia'
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar el certificado de participación en la conferencia'
                        break;                        
                    default:
                        label = name;
                        break;
                }                
                break;
            case 32://Solicitud de Patente
                switch(name){
                    case 'adjunto':
                        label='Adjuntar PDF de la Patente';
                        break;
                    case 'adjunto2':
                        label='*Adjuntar Figuras';
                        break;
                    case 'adjunto3':
                        label='*Adjuntar Descripción';
                        break;
                    case 'adjunto4':
                        label='*Adjuntar Solicitud de ingreso de Patente';
                        break;
                    case 'adjunto5':
                        label='*Adjuntar Notificación de ingreso de Patente';
                        break;  
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;                                              
                    default:
                        label=name;
                        break;
                }
                break;
            case 33://Derecho de Autor
                switch(name){
                    case 'adjunto':
                        label='*Registro de derecho de autor'
                        break;
                    case 'adjunto2':
                        label='*Aduntar Notificación de registro'
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    }
                break;
            case 34://NUEVA OBTENCION VEGETAL
                switch(name){
                    case 'adjunto':
                        label='*Adjuntar Solicitud de ingreso de Derecho Obtentor'
                        break;
                    case 'adjunto2':
                        label='*Adjuntar Notificación de ingreso de Derecho Obtentor'
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label=name;
                        break;
                    }
                break;
            case 35://caso Estudio
                switch(name){
                    case 'fevento':
                        label = 'Fecha de registro: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Metodología: '
                        break;
                    case 'asistObjetiv':
                        label = 'Objetividad: ';
                        break;
                    case 'innovaVerific':
                        label = 'Verificabilidad: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Sistematicidad: ';
                        break;
                    case 'retosComunic':
                        label = 'Comunicabilidad: ';
                        break; 
                    case 'adjunto':
                        label='Adjuntar PDF del caso de estudio';
                        break;
                    case 'adjunto2':
                        label='Adjuntar Otra Evidencia'
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 36://POSTER CONFERENCIA
                switch(name){
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'adjunto':
                        label='*Adjuntar póster de la conferencia';
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar certificado de participación';
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 37://Infraestructura/Equipamento
                switch(name){
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Área / Laboratorio: '
                        break;
                    case 'fevento':
                        label = 'Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                        break;
                    case 'marca':
                        label = 'Marca: '
                        break;
                    case 'modelo':
                        label = 'Modelo: '
                        break;
                    case 'serie':
                        label = 'Número de Serie (ID): '
                        break;
                    case 'invetario':
                        label = 'Número Inventario de ESPOL/ESPOLTECH: '
                        break;
                    case 'estado':
                        label = 'Estado: '
                        break;  
                    case 'frecuencia':
                        label = 'Frecuencia de USO: '
                        break;
                    case 'asistObjetiv':
                        label = 'Usuarios: '
                        break;   
                    case 'fechapublicacion':
                        label = 'Fecha de Compra - Obligatorio solo si escoge la opción de "NUEVO": '
                        break;
                    case 'palabrasClave':
                            label = 'Responsable: '
                            break;
                    case 'especificacion':
                        label = 'Especificación Técnica: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'isindex':
                        label = 'Condiciones de Brindar Servicio: '
                        break;
                    case 'adjunto':
                        label='*Adjuntar Ficha técnica del Equipo';
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 38://Infraestructura/Laboratorio
                switch(name){
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Ubicación: '
                        break;
                    case 'tipolab':
                        label = 'Tipo de Laboratorio: '
                        break;                         
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'resumen':
                        label = 'Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'adjunto':
                        label = '*Informe de creación de laboratorio (imágenes)';
                        break;
                    default:
                        label = name;
                        break;
                }                
                break; 
            case 39://Organización y ejecución de Taller/Curso/Conferencia
                switch(name){
                    case 'nevento':
                        label = 'Temática: '
                        break;
                    case 'levento':
                        label = 'Lugar: '
                        break;
                    case 'fevento':
                        label = 'Fecha: '
                        break;
                    case 'adjunto':
                        label = '*Presentación del taller';
                        break;
                    case 'adjunto2':
                        label = '*Listado de asistencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar Otro tipo de Evidencia';
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 40://Metodología/Protocolo implementado
                switch(name){
                    case 'codigoproducto':
                        label = 'Código: '
                        break;
                    case 'especificacion':
                        label = 'Especificaciones: '
                        break;
                    case 'adjunto':
                        label='*Adjuntar PDF del Producto';
                        break;
                    case 'adjunto2':
                        label='Adjuntar Notificación de Aceptación(En caso de que exista)';
                        break;
                    case 'adjunto3':
                        label='Adjuntar Prueba de Revisión de Pares(En caso de ser requerido)';
                        break;
                    case 'adjunto4':
                        label='Adjuntar Otro tipo de Evidencia';
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 41://Proyecto de titulación grado
                switch(name){
                    case 'fevento':
                        label = 'Fecha de Titulación: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;                    
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                    }
                break;
            case 42://Proyecto de titulación de maestría profesional
                switch(name){
                    case 'fevento':
                        label = 'Fecha de Titulación: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;                    
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label='*Adjuntar PDF de tesis';
                        break;
                    case 'adjunto2':
                        label='*Diploma o certificado de titulación';
                    break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 43://Participación en conferencia (sin artículo)
                switch(name){
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'adjunto':
                        label='*Adjuntar certificado de participación';
                        break;
                    default:
                        label = name;
                        break;
                }                
                break;
            case 44://Secreto Empresarial o información no divulgada
                switch(name){
                    case 'adjunto':
                        label = '*Aduntar Notificación de registro'
                        break;
                    case 'adjunto2':
                        label='*Registro del depósito de información no divulgada (Secreto)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            default:
                switch(name){
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    case 'asistObjetiv':
                        label = 'Objetividad: ';
                        break;
                    case 'innovaVerific':
                        label = 'Verificabilidad: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Sistematicidad: ';
                        break;
                    case 'retosComunic':
                        label = 'Comunicabilidad: ';
                        break;
                    default:
                        label = name;
                        break;
                }                
            break;
        }
        return label;
    }
    function IndexHandle(id:number): string{
        let flat = "";
        switch(id){
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                flat = 'INDEXACION-SCOPUS-WOS';
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                flat = 'OTRAS-INDEXACIONES';                
                break;
            default:
                flat = 'ALL-BD';
                break;
        }
        return flat;
    }
    function validarPorcentajePart(colaboradores: Array<ProductoColaboradorDTO>): boolean{
        let total = 0;
        colaboradores.forEach(element => {
            // Convierte el valor a número utilizando parseFloat
            const porcentajeComoNumero = parseFloat(element.porcentajeparticipacion.toString());

            // Verifica si la conversión fue exitosa y el valor no es NaN
            if (!isNaN(porcentajeComoNumero)) {
                total = total + porcentajeComoNumero;
                //console.log(total);
            } else {
                console.error(`El valor "${element.porcentajeparticipacion}" no es un número válido.`);
                return false;
            }
        });        
        return total === 100;
    }
    function ListIndexHandle(listIndex: Array<IndexacionDTO>,id:number): Array<IndexacionDTO>{
        let list = listIndex;
        switch(id){
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS');
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES) 
                list = list.filter(x => x.catagPadre === 'OTRAS-INDEXACIONES');               
                break;
            case 7://Libro o capitulo  ANTIGUO
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS' || x.catagPadre === 'OTRAS-INDEXACIONES');               
                break;
            case 28://Libro o capitulo 
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS' || x.catagPadre === 'OTRAS-INDEXACIONES');               
                break;
            default:
                break;
        }
        return list;
    }
    function alertConferencia(){
        Swal.fire({
            title: 'Conferencia',
            text: "¿El artículo proviene de una conferencia?, si responde afirmativamente la página se recargará que ingrese la información de dicha conferencia.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            } else if (
              /* Read more about handling dismissals below */
              result.dismiss === Swal.DismissReason.cancel
            ) {
              Swal.fire(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }
          })
    }
    const save = async (values:any) =>{
        //console.log("Post",values);
        const fechaNula = new Date(1, 0, 1);
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        let productoFinal = getVoidProdcutoTerminadoDTO();
        productoFinal.idpersona = idpersona; 
        alertaService.showLoading("Espere...");
        //Motivo
            productoFinal.motivo.iddecinvmotivoprodtermin = values.iddecinvmotivoprodtermin;
            productoFinal.motivo.idpersona = values.idusuariocrea === 0 ? idusuariocrea : values.idusuariocrea; 
            productoFinal.motivo.tipomotivo = values.tipomotivo; 
            productoFinal.motivo.motivo =  values.motivo;
            productoFinal.motivo.ultimoCambio = format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        if(values.tieneProyecto === 'S'){
            productoFinal.motivo.iddecinvmotivoprodtermin = values.iddecinvmotivoprodtermin;
            productoFinal.motivo.idpersona = values.idusuariocrea === 0 ? idusuariocrea : values.idusuariocrea; 
            productoFinal.motivo.tipomotivo = 'O'; 
            productoFinal.motivo.motivo = 'PRODUCTO INGRESADO AL PROYECTO POR';
            productoFinal.motivo.ultimoCambio = format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        }        
        //Producto      
        productoFinal.producto.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.producto.iddecinvproyecto = values.idproyecto;
        if(values.tieneProyecto === 'N'){
            productoFinal.producto.iddecinvproyecto = 0;
        }
        productoFinal.producto.iddecinvmotivoprodtermin = values.idmotivo;
        productoFinal.producto.titulo = values.titulo;        
        productoFinal.producto.iddecinvtipoproductoesperado = values.tipo;
        productoFinal.producto.anio = values.anio;
        productoFinal.producto.url = values.url;
        productoFinal.producto.doi = values.doi;        
        productoFinal.producto.bdrevista = values.bdrevista;
        productoFinal.producto.nombrerevista = values.nombreRevista;
        productoFinal.producto.issn = values.codISSN;
        //productoFinal.producto.Url = values.urlRevista;
        productoFinal.producto.factimpacto = values.impactoIndex;
        productoFinal.producto.sjr = values.impactoSJR;
        productoFinal.producto.cuartil = values.cuartil;
        productoFinal.producto.volumen = values.volumen;
        productoFinal.producto.paginas = values.paginas;
        productoFinal.producto.keys = values.palabrasClave;
        productoFinal.producto.resumen = values.resumen;
        productoFinal.producto.revisionpares = values.revisionpares;
        productoFinal.producto.idunidad = values.idunidad;
        productoFinal.producto.nevento = values.nevento;
        productoFinal.producto.levento = values.levento;
        productoFinal.producto.estado = values.estado;
        productoFinal.producto.marca = values.marca;
        productoFinal.producto.modelo = values.modelo;
        productoFinal.producto.serie = values.serie;
        productoFinal.producto.inventario = values.inventario;
        productoFinal.producto.estado = values.estado;
        productoFinal.producto.frecuencia = values.frecuencia;
        productoFinal.producto.asistObjetiv = values.asistObjetiv;
        productoFinal.producto.especificacion = values.especificacion;
        productoFinal.producto.isindex = values.isindex;  
        productoFinal.producto.editorial = values.editorial; 
        productoFinal.producto.estadopublicacion = values.estadopublicacion;        
        productoFinal.producto.innovaVerific = values.innovaVerific;
        productoFinal.producto.logrosSistemac = values.logrosSistemac; 
        productoFinal.producto.retosComunic = values.retosComunic;  
        productoFinal.producto.iddecinvrevista = values.iddecinvrevista; 
        productoFinal.producto.aprobado = values.aprobado;  
        productoFinal.producto.observacionarpob = values.observacionarpob; 
        productoFinal.producto.idpublicacionpersona = values.idpublicacionpersona;
        productoFinal.producto.codigoproducto = values.codigoproducto;
        productoFinal.producto.tipotesis = values.tipotesis; 
        productoFinal.producto.inventor = values.inventor;
        productoFinal.producto.adjunto = values.adjunto;
        productoFinal.producto.adjunto2 = values.adjunto2;
        productoFinal.producto.adjunto3 = values.adjunto3;
        productoFinal.producto.adjunto4 = values.adjunto4;
        productoFinal.adjuntos = values.adjuntos;
        //Control fechas
        productoFinal.producto.fechapublicacion = format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        if(FormTypeHandle(values.tipo,'fechapublicacion')){
            productoFinal.producto.fechapublicacion = values.fechapublicacion; 
        }               
        productoFinal.producto.fvencimiento = format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        if(FormTypeHandle(values.tipo,'fvencimiento')){
            productoFinal.producto.fvencimiento = values.fvencimiento;
        }
        productoFinal.producto.fevento = format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        if(FormTypeHandle(values.tipo,'fevento')){
            productoFinal.producto.fevento = values.fevento;
        }
        productoFinal.producto.ultimoCambio = format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        //AreaConocimiento
        productoFinal.areaConocimiento.iddecinvproductoareaconocimiento = values.iddecinvproductoareaconocimiento;
        productoFinal.areaConocimiento.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.areaConocimiento.iddecinvtipoproductoesperado = values.tipo; 
        productoFinal.areaConocimiento.codarea = values.codarea; 
        productoFinal.areaConocimiento.codsubarea = values.codsubarea; 
        productoFinal.areaConocimiento.codsubareadetallada = values.codsubareadetallada;
        productoFinal.areaConocimiento.ultimoCambio =  format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        //lineaInvestigacion
        productoFinal.lineaInvestigacion.iddecinvproductolineainvestigacion = values.iddecinvproductolineainvestigacion;
        productoFinal.lineaInvestigacion.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.lineaInvestigacion.iddecinvtipoproductoesperado = values.tipo;  
        productoFinal.lineaInvestigacion.iddecinvareaconocimiento = values.iddecinvareaconocimiento === 0 ? null : values.iddecinvareaconocimiento;
        productoFinal.lineaInvestigacion.lineainvestigacion = values.lineainvestigacion;
        productoFinal.lineaInvestigacion.ultimoCambio= format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        //ods
        productoFinal.ods.iddecinvproductoterminadoobjods = values.iddecinvproductoterminadoobjods;
        productoFinal.ods.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.ods.iddecinvtipoproductoesperado = values.tipo;
        productoFinal.ods.iddecinvobjods = values.iddecinvobjods;
        productoFinal.ods.ultimoCambio = format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        //Colaboladores 
        productoFinal.colProducto = values.colaboradores;
        //console.log('objeto: ',productoFinal);
        if(productoFinal.producto.iddecinvtipoproductoesperado === 32 || productoFinal.producto.iddecinvtipoproductoesperado === 34){
            let bandera = validarPorcentajePart(productoFinal.colProducto);
            if(!bandera){
                alertaService.hideLoading();
                alertaService.alertaAdvertencia("Error","El porcentaje de participación de los colocaboradores en total no es 100.");
            }else{
                const resp = await productoService.GuardarProductoTerminadoIDatos(productoFinal,token);
                alertaService.hideLoading();
                if(resp.strEstado == 'S') {
                    alertaService.alertaExito("Exito","Se guardo el producto.");
                    goToNavigation('/Producto/MisProductos');
                }else{
                    alertaService.alertaAdvertencia("Error",resp.strMensaje);
                }
            }
        }else{
            const resp = await productoService.GuardarProductoTerminadoIDatos(productoFinal,token);
          alertaService.hideLoading();
          if(resp.strEstado == 'S') {
            if([24,25].includes(productoFinal.producto.iddecinvtipoproductoesperado) && productoFinal.producto.iddecinvproyectoprodtermin === 0){
                alertaService.alertaProductoConferencia('¿El artículo proviene de una conferencia?','Si responde afirmativamente la página se recargará para que ingrese la información de dicha conferencia.',resp.objDatos.producto.iddecinvproyectoprodtermin);
            }else{
                alertaService.alertaExito("Exito","Se guardo el producto.");
                goToNavigation('/Producto/MisProductos');
            }             
          }else{
             alertaService.alertaAdvertencia("Error",resp.strMensaje);
          }
        }
    }  
    const handleAddRow = (values: { colaboradores: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        const newRow = { 
            iddecinvproyectoprodtermin: idProd,
            iddecinvproyectocolaboradores: 0,
            iddecinvproyectoprtercol: 0,
            iddecinvproyecto: 0,
            iddecinvrolinvestigador: 0,
            cedula: '',
            tipocolaborador: 1,
            tipoparticipacion: 1,
            nombre: '',
            email:'',
            institucion: '',
            idunidad: 0,
            escolabproyecto: 1,
            enescalafon: '',
            considerarestimulo: '',
            estimulo: '',
            titulosubproyecto: '',
            porcentajeparticipacion: 0,
            fechacheckescalafon: format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            fechaingresoproyecto: format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            fechasalidaproyecto: format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            ultimoCambio: format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
        }; // Puedes inicializar los valores según tus necesidades
        setFieldValue('colaboradores', [...values.colaboradores, newRow]);
    };
    const handleAddRowColaborador = (values: { colaboradores: any; },colaborador: ProyectoColaboradoreDTO, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        const newRow = { 
            iddecinvproyectoprodtermin: idProd,
            iddecinvproyectocolaboradores: colaborador.iddecinvproyectocolaboradores,
            iddecinvproyectoprtercol: 0,
            iddecinvproyecto: colaborador.iddecinvproyecto,
            iddecinvrolinvestigador: colaborador.iddecinvrolinvestigador,
            cedula: colaborador.cedula,
            tipocolaborador: colaborador.tipocolaborador,
            tipoparticipacion: 1,
            nombre: colaborador.nombre,
            email: colaborador.email,
            institucion: colaborador.institucion,
            idunidad: colaborador.idunidad === null ? 0 : colaborador.idunidad,
            escolabproyecto: 1,
            enescalafon: colaborador.enescalafon,
            considerarestimulo: colaborador.considerarestimulo,
            estimulo: colaborador.estimulo,
            titulosubproyecto: colaborador.titulosubproyecto,
            porcentajeparticipacion: colaborador.porcentajeparticipacion === null ? 0 : colaborador.porcentajeparticipacion,
            fechacheckescalafon: colaborador.fechacheckescalafon === null ? format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"): colaborador.fechacheckescalafon,
            fechaingresoproyecto: colaborador.fechaingresoproyecto === null ? format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"): colaborador.fechaingresoproyecto,
            fechasalidaproyecto: colaborador.fechasalidaproyecto === null ? format(fechaNula,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX"): colaborador.fechasalidaproyecto,
            ultimoCambio: format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
        }; // Puedes inicializar los valores según tus necesidades
        setFieldValue('colaboradores', [...values.colaboradores, newRow]);
    };
    const handleRemoveRow = async (index: number, values: { colaboradores: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const updatedColaboradores = [...values.colaboradores];
        const idToRemove = updatedColaboradores[index].iddecinvproyectoprtercol;
        if(idToRemove === 0){
          updatedColaboradores.splice(index, 1);
          setFieldValue('colaboradores', updatedColaboradores);
        }else{
            //aqui colocar funcion para eliminar
            const delCol = updatedColaboradores[index] as ProyectoColaboradoreDTO; 
            //console.log(delCol)
            const respuesta = await productoService.DeleteColaboradorProducto(delCol.iddecinvproyecto,delCol.iddecinvproyectocolaboradores,token);
            if(respuesta.status.isSuccessfully){
                updatedColaboradores.splice(index, 1);
                setFieldValue('colaboradores', updatedColaboradores);
                alertaService.alertaExito('Eliminar','Colaborador Eliminado');
            }else{
                alertaService.alertaAdvertenciaList('Eliminar',respuesta.status.messages);
            }
        }
    };
    function setListSubaArea(idarea:number){
        catalogService.obtenerGetSubAreas(idarea)
            .then((data) => {
                //console.log(data.objDatos);
                setSubAreasCine(data.listData);
            })               
            .catch((error) => console.error(error));
    };
    function setListSubaAreaDet(idsubarea:number){
        catalogService.obtenerGetSubAreas(idsubarea)
            .then((data) => {
                //console.log(data.objDatos);
                setSubAreasCineDet(data.listData);
            })               
            .catch((error) => console.error(error));
    };
    //Seccion Carga
    useEffect(() => {
        const fetchData = async () =>{
          try{
               alertaService.showLoading("Cargando Datos Producto");
               setAnios(catalogService.generateYearList(2015,anioActual))
               setDesicion(catalogService.getDecision)
               setTieneproy(catalogService.getDecision)
               setQuartil(catalogService.getCuartil)
               setMotivos(catalogService.getMotivoProducto)
               setListRolColaborador(catalogService.getRolColaboradorProducto)
               setTipoColaborador(catalogService.getTipoColaborador) 
               setEstadoEquipo(catalogService.getEstadoEquipo);  
               setFrecuencia(catalogService.getFrecuencia);
               await productoService.GetProductoTerminadoById(parseInt(idProducto || '0'),token)
               .then((data) => setProducto(data))               
               .catch((error) => console.error(error));          
               await catalogService.obtenerCatalogoTipoProducto()
               .then((data) => setTipoProductos(data.listData))
               .catch((error) => console.error(error))
               await catalogService.obtenerCatalogoUnidades()
               .then((data) => setUnidades(data.objDatos))
               .catch((error) => console.error(error))                
               await catalogService.obtenerGetIndexCatalog()
               .then((data) => setListIndex(data.listData))
               .catch((error) => console.error(error))
               await catalogService.obtenerGetMisProyectoEjecucion(casUserContext.userData.idinv,token)
               .then((data) => {
                    //console.log(data);
                    setMisProyectos(data.listData);
                    //console.log(misProyectos);
                })               
               .catch((error) => console.error(error));
               catalogService.obtenerGetObjODS()
               .then((data) => {
                //console.log(data.objDatos);
                setListODS(data.objDatos);
                })               
                .catch((error) => console.error(error));
                catalogService.obtenerGetAreasConocimiento()
               .then((data) => setAreasCine(data.listData))
               .catch((error) => console.error(error))
               catalogService.obtenerGetAreasLineasInvestigacion()
               .then((data) => {
                //console.log(data.objDatos);
                setAreasLineasInvestigacion(data.listData);
                })               
                .catch((error) => console.error(error));
               alertaService.hideLoading();                
          }catch(error){
            console.error('Error:',error);
          }
        };
        fetchData();
        },[]);
    
    if (!ready) {
       // Mostrar una interfaz de carga mientras se obtienen los datos
       return <CircularProgress color="secondary" />;
    }
    //Seccion Formulario
    return(
        <div className='formualrioGeneral'>
        <Card>
        <CardHeader style={cardHeaderStyles}>
            <strong>Formulario Producto</strong>
            <IconButton aria-label="delete" color="success" onClick={() => goToNavigation('/Producto/MisProductos')}>
                <AiFillCaretLeft />
            </IconButton>
        </CardHeader>
        <CardBody>
        <Formik 
        initialValues={{
            apellidosBusqueda: apellidosBusqueda,
            mailBusqueda: mailBusqueda,
            //producto
            iddecinvmotivoprodtermin: datosFormulario.producto.iddecinvmotivoprodtermin,
            idusuariocrea: datosFormulario.motivo.idpersona,
            tipomotivo: datosFormulario.motivo.tipomotivo,
            motivo: datosFormulario.motivo.motivo,
            idproductoterminado: datosFormulario.producto.iddecinvproyectoprodtermin,
            idproyecto: datosFormulario.producto.iddecinvproyecto,
            tieneProyecto: datosFormulario.producto.iddecinvproyecto === null || datosFormulario.producto.iddecinvproyecto === 0 ? 'N' : 'S',
            idmotivo: datosFormulario.producto.iddecinvmotivoprodtermin,             
            titulo: datosFormulario.producto.titulo,
            tipo: datosFormulario.producto.iddecinvtipoproductoesperado,
            anio: datosFormulario.producto.anio > 0 ? datosFormulario.producto.anio : anioActual,
            url: datosFormulario.producto.url,
            doi: datosFormulario.producto.doi,
            fechapublicacion: datosFormulario.producto.fechapublicacion.length > 0 ? convertirFormatoFecha(datosFormulario.producto.fechapublicacion) : format(new Date(),'yyyy-MM-dd'),
            //fechapublicacion: datosFormulario.producto.fechapublicacion.length > 0 ? format(parse(datosFormulario.producto.fechapublicacion, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(),'yyyy-MM-dd'),
            //fechapublicacion: datosFormulario.producto.fechapublicacion.toFormatYYYYMMD(),
            bdrevista: datosFormulario.producto.bdrevista,
            nombreRevista: datosFormulario.producto.nombrerevista,
            codISSN: datosFormulario.producto.issn,
            urlRevista: '',            
            impactoIndex: datosFormulario.producto.factimpacto,
            impactoSJR: datosFormulario.producto.sjr,
            cuartil: datosFormulario.producto.cuartil,
            volumen: datosFormulario.producto.volumen,
            paginas: datosFormulario.producto.paginas,
            palabrasClave: datosFormulario.producto.keys,
            resumen: datosFormulario.producto.resumen,
            revisionpares: datosFormulario.producto.revisionpares,
            tipolab: datosFormulario.producto.tipolab,
            nevento: datosFormulario.producto.nevento,
            levento: datosFormulario.producto.levento,
            fevento: datosFormulario.producto.fevento.length > 0 ? convertirFormatoFecha(datosFormulario.producto.fevento) : format(new Date(),'yyyy-MM-dd'),
            //fevento: datosFormulario.producto.fevento.length > 0 ? format(parse(datosFormulario.producto.fevento, "d/M/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(),'yyyy-MM-dd'),
            // fevento:datosFormulario.producto.fevento.toFormatYYYYMMD(),
            idunidad: datosFormulario.producto.idunidad,
            estado: datosFormulario.producto.estado,
            marca: datosFormulario.producto.marca,
            modelo: datosFormulario.producto.modelo,
            serie: datosFormulario.producto.serie,
            inventario: datosFormulario.producto.inventario,
            frecuencia: datosFormulario.producto.frecuencia,
            asistObjetiv: datosFormulario.producto.asistObjetiv,
            especificacion: datosFormulario.producto.especificacion,
            isindex: datosFormulario.producto.isindex,  
            editorial: datosFormulario.producto.editorial, 
            estadopublicacion: datosFormulario.producto.estadopublicacion,        
            innovaVerific: datosFormulario.producto.innovaVerific, 
            logrosSistemac: datosFormulario.producto.logrosSistemac, 
            retosComunic: datosFormulario.producto.retosComunic,  
            fvencimiento: datosFormulario.producto.fvencimiento.length > 0 ? convertirFormatoFecha(datosFormulario.producto.fvencimiento) : format(new Date(),'yyyy-MM-dd'),
            //fvencimiento: datosFormulario.producto.fvencimiento.length > 0 ? format(parse(datosFormulario.producto.fvencimiento, "d/M/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(),'yyyy-MM-dd'),
            //fvencimiento:datosFormulario.producto.fvencimiento.toFormatYYYYMMD(),
            iddecinvrevista: datosFormulario.producto.iddecinvrevista, 
            aprobado: datosFormulario.producto.aprobado,  
            observacionarpob: datosFormulario.producto.observacionarpob, 
            idpublicacionpersona: datosFormulario.producto.idpublicacionpersona,
            codigoproducto: datosFormulario.producto.codigoproducto,
            tipotesis: datosFormulario.producto.tipotesis, 
            inventor: datosFormulario.producto.inventor,
            adjunto: datosFormulario.producto.adjunto,
            adjunto2: datosFormulario.producto.adjunto2,
            adjunto3: datosFormulario.producto.adjunto3,
            adjunto4: datosFormulario.producto.adjunto4,
            //AreaConocimiento
            iddecinvproductoareaconocimiento: datosFormulario.areaConocimiento.iddecinvproductoareaconocimiento, 
            codarea: datosFormulario.areaConocimiento.codarea, 
            codsubarea: datosFormulario.areaConocimiento.codsubarea, 
            codsubareadetallada: datosFormulario.areaConocimiento.codsubareadetallada,
            //lineaInvestigacion
            iddecinvproductolineainvestigacion: datosFormulario.lineaInvestigacion.iddecinvproductolineainvestigacion,  
            iddecinvareaconocimiento: datosFormulario.lineaInvestigacion.iddecinvareaconocimiento, 
            lineainvestigacion: datosFormulario.lineaInvestigacion.lineainvestigacion, 
            //ods
            iddecinvproductoterminadoobjods: datosFormulario.ods.iddecinvproductoterminadoobjods,
            iddecinvobjods: datosFormulario.ods.iddecinvobjods,
            //colaboradores
            colaboradores: datosFormulario.colProducto as Array<ProductoColaboradorDTO>,
            adjuntos: datosFormulario.adjuntos as Array<FileModel>,
            archivo1:null,
            archivo2:null,
            archivo3:null,
            archivo4:null,
        }}
        validationSchema={validationSchema}
        onSubmit={save}        
        >
           {({isValid,setFieldValue,values,errors,touched,handleSubmit,handleChange,handleBlur}) => (
            <Form onSubmit={handleSubmit}>
            {values.idproductoterminado === 0 && (
                <Grid className='motivo' container spacing={2}>                
                <Grid item xs={12} sm={12} md={6} lg={6}>
                <FormControl sx={{ m: 1, minWidth: '100%' }} size='small' error={Boolean(errors.tieneProyecto && touched.tieneProyecto)} >
                <InputLabel htmlFor="tieneProyecto">Tiene Proyecto:</InputLabel>
                <Field 
                    as={Select}
                    name="tieneProyecto"
                    variant="outlined"                
                    value={values.tieneProyecto}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    {tieneproy.map((q) => (
                        <MenuItem key={q.value} value={q.value}>
                        {q.label}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='tieneProyecto' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
                </Grid>
            )}            
            {values.idproductoterminado === 0 && values.tieneProyecto === 'N' &&(
                <Grid className='motivo' container spacing={2}>                
                <Grid item xs={12} sm={12} md={9} lg={6}>
                   <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.tipomotivo && touched.tipomotivo)} >                   
                   <InputLabel htmlFor="tipomotivo">La razón de porque no está asociado a un proyecto:</InputLabel>
                   <Field 
                       as={Select}
                       name="tipomotivo"
                       type="text"
                       variant="outlined"                
                       value={values.tipomotivo}
                       onChange={handleChange}
                       onBlur={handleBlur}                                   
                   >
                       {motivos.map((tipoP) => (
                           <MenuItem key={tipoP.value} value={tipoP.value}>
                           {tipoP.label}                    
                           </MenuItem>
                       ))}
                       <MenuItem key={"null-Tipo"} value={0} >
                           {'Ninguno'}                    
                       </MenuItem>
                   </Field>
                   <ErrorMessage name='tipomotivo' className='errorMessage' component="div"/>
                </FormControl>
               </Grid>
               <Grid item xs={12} sm={12} md={12} lg={12}>           
               <Field 
                    as={TextField}
                    name="motivo"
                    label="Por favor de una explicación breve del trabajo realizado para lograr este producto:"
                    variant="outlined" 
                    sx={{ m: 1, width: '100%' }}                
                    type="text"
                    multiline 
                    rows={3}
                    values={values.motivo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.motivo && touched.motivo)}
                    helperText={<ErrorMessage name='motivo' />}                
                    />
               </Grid>
               </Grid>  
            )}
            {values.tieneProyecto === 'S' &&(
                <Grid className='proyecto' container spacing={2}>               
                <Grid item xs={12} sm={12} md={12} lg={12}>
                   <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.idproyecto && touched.idproyecto)} >                   
                   <InputLabel htmlFor="idproyecto">Proyecto:</InputLabel>
                   <Field 
                       as={Select}
                       name="idproyecto"
                       type="text"
                       variant="outlined"                
                       value={values.idproyecto}
                       onChange={async (e: ChangeEvent<{ name?: string; value: number }>) => {
                              const selectedValue = e.target.value;
                              // Llama a tu función externa para obtener datos de la API
                                try {
                                    const apiData = await setListColaboradores(selectedValue);              
                                    handleChange(e);
                                } catch (error) {
                                    // Maneja el error aquí si es necesario
                                }
                            }}
                       onBlur={handleBlur}                                   
                   >
                       {misProyectos.length > 0 ? (
                        misProyectos.map((tipoP) => (
                            <MenuItem key={tipoP.codigo} value={tipoP.codigo}>
                            {tipoP.descripcion}
                            </MenuItem>
                        ))
                        ) : (
                        <MenuItem value={''}>No hay proyectos disponibles</MenuItem>
                        )}
                       <MenuItem key={"null-proyecto"} value={0} >
                           {'Ninguno'}                    
                       </MenuItem>
                   </Field>
                   <ErrorMessage name='idproyecto' className='errorMessage' component="div"/>
                </FormControl>
               </Grid>
               </Grid>  
            )}                       
            <Grid className='siempre' container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Field 
                as={TextField}
                name="titulo"
                label="Titulo Producto"
                variant="outlined" 
                sx={{ m: 1, width: '100%' }}                
                type="text" 
                values={values.titulo}
                onChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(errors.titulo && touched.titulo)}
                helperText={<ErrorMessage name='titulo' />}                
            />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
            <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.tipo && touched.tipo)} >
                <InputLabel htmlFor="tipo">Tipo</InputLabel>
                <Field 
                    as={Select}
                    name="tipo"
                    type="text"
                    variant="outlined"                
                    value={values.tipo}
                    onChange={async (e: ChangeEvent<{ name?: string; value: number }>) => {
                        const selectedValue = e.target.value;
                        // Llama a tu función externa para obtener datos de la API
                          try {
                              const apiData = await listRolAjust(selectedValue);              
                              handleChange(e);
                          } catch (error) {
                              // Maneja el error aquí si es necesario
                          }
                      }}
                    onBlur={handleBlur}                                   
                >
                    {tipoProductos.map((tipoP) => (
                        <MenuItem key={tipoP.idProducto} value={tipoP.idProducto}>
                        {tipoP.nombreProducto}                    
                        </MenuItem>
                    ))}
                    <MenuItem key={"null-Tipo"} value={0} >
                        {'Ninguno'}                    
                    </MenuItem>
                </Field>
                <ErrorMessage name='tipo' className='errorMessage' component="div"/>
            </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
            <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.tipo && touched.tipo)} >
                <InputLabel htmlFor="tipo">Categoría</InputLabel>
                <Field 
                    as={Select}
                    name="tipo"
                    type="text"
                    variant="outlined"                
                    value={values.tipo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled           
                >
                    {tipoProductos.map((tipoP) => (
                        <MenuItem key={tipoP.idProducto} value={tipoP.idProducto}>
                        {tipoP.nombreCategoria}                    
                        </MenuItem>
                    ))}
                    <MenuItem key={"null-Tipo"} value={0} >
                        {'Ninguno'}                    
                    </MenuItem>
                </Field>
                <ErrorMessage name='tipo' className='errorMessage' component="div"/>
            </FormControl>
            </Grid>
            </Grid>
            {values.tipo > 0 && (
                <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                <CardUI>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                         {FormTitleColHandle(values.tipo)}
                      </Typography>
                      <Table>
                        <TableHead>
                            <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Cedula</TableCell>
                            <TableCell>Apellidos y Nombres</TableCell>
                            <TableCell>Tipo Colaborador</TableCell>
                            <TableCell>Unidad Espol</TableCell>
                            <TableCell>Institucion</TableCell>
                            <TableCell>Correo</TableCell>
                            <TableCell>Rol</TableCell>
                            {usoParticipacion(values.tipo) ? <TableCell>% Participacion</TableCell> : <></>}
                            <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {values.colaboradores.map((colaborador,index) => (
                            <TableRow key={'col-'+index}>
                                <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).cedula &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).cedula
                                        )
                                    }
                                    >
                                    <TextField
                                        name={`colaboradores[${index}].cedula`}
                                        type="text"
                                        placeholder="0987654321"
                                        value={colaborador.cedula}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).cedula &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).cedula
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).cedula
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).nombre &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).nombre
                                        )
                                    }
                                    >
                                    <TextField
                                        name={`colaboradores[${index}].nombre`}
                                        type="text"
                                        placeholder="Zambrano Herrera Zacarias Miguel"
                                        value={colaborador.nombre}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).nombre &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).nombre
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).nombre
                                        : ''}
                                    </FormHelperText>
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipocolaborador &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipocolaborador
                                        )
                                    }
                                    >                        
                                    <Select
                                        name={`colaboradores[${index}].tipocolaborador`}
                                        value={colaborador.tipocolaborador}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        >                             
                                        {/* Agrega más roles según sea necesario */}
                                        {tipoColaborador.map((rol) => (
                                            <MenuItem key={rol.id} value={rol.id}>
                                            {rol.label}                    
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipocolaborador &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipocolaborador
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipocolaborador
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).idunidad &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).idunidad
                                        )
                                    }
                                    >                        
                                    <Select
                                        name={`colaboradores[${index}].idunidad`}
                                        value={colaborador.idunidad}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        >                             
                                        {/* Agrega más roles según sea necesario */} 
                                        <MenuItem key={"null-unidad-col"} value="0">Ninguna</MenuItem>                                       
                                        {unidades.map((rol) => (
                                            <MenuItem key={rol.idunidad} value={rol.idunidad}>
                                            {rol.codacad}                    
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).idunidad &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).idunidad
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).idunidad
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).institucion &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).institucion
                                        )
                                    }
                                    >
                                    <TextField
                                        name={`colaboradores[${index}].institucion`}
                                        type="text"
                                        placeholder="Espol"
                                        value={colaborador.institucion}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).institucion &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).institucion
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).institucion
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).email &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).email
                                        )
                                    }
                                    >
                                    <TextField
                                        name={`colaboradores[${index}].email`}
                                        type="text"
                                        placeholder="example@espol.edu.ec"
                                        value={colaborador.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).email &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).email
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).email
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell>
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipoparticipacion &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipoparticipacion
                                        )
                                    }
                                    >                        
                                    <Select
                                        name={`colaboradores[${index}].tipoparticipacion`}
                                        value={colaborador.tipoparticipacion}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        >
                                        <MenuItem value="0">Seleccionar Rol</MenuItem>                              
                                        {/* Agrega más roles según sea necesario */}
                                        {listRolColaborador.map((rol) => (
                                            <MenuItem key={rol.id} value={rol.id}>
                                            {rol.label}                    
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipoparticipacion &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipoparticipacion
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).tipoparticipacion
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell>
                                {usoParticipacion(values.tipo) ? 
                                <TableCell>
                                <FormControl
                                    error={
                                        Boolean(
                                        errors &&
                                        errors.colaboradores &&
                                        typeof errors.colaboradores[index] === 'object' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).porcentajeparticipacion &&
                                        touched.colaboradores &&
                                        typeof touched.colaboradores[index] === 'object' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).porcentajeparticipacion
                                        )
                                    }
                                    >
                                    <TextField
                                        name={`colaboradores[${index}].porcentajeparticipacion`}
                                        type="text"
                                        placeholder="100"
                                        value={colaborador.porcentajeparticipacion}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <FormHelperText>
                                        {errors &&
                                        typeof errors.colaboradores !== 'undefined' &&
                                        (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).porcentajeparticipacion &&
                                        touched &&
                                        typeof touched.colaboradores !== 'undefined' &&
                                        (touched.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).porcentajeparticipacion
                                        ? (errors.colaboradores[index] as FormikErrors<ProductoColaboradorDTO>).porcentajeparticipacion
                                        : ''}
                                    </FormHelperText>
                                </FormControl>
                                </TableCell> 
                                : <></>}
                                <TableCell>
                                <IconButton aria-label="Eliminar" color='error' onClick={() => handleRemoveRow(index, values, setFieldValue)}>
                                <AiFillDelete />
                                </IconButton>
                                </TableCell>
                            </TableRow>
                            ))}                    
                        </TableBody>
                      </Table>
                <ErrorMessage name='colaboradores' className='errorMessage' component="div"/>
                    </CardContent>
                    <CardActions>
                        <IconButton aria-label="add" color="info" onClick={() => handleAddRow(values, setFieldValue)} >
                        <BiAddToQueue />
                        </IconButton>
                        <IconButton aria-label="add" color="info" onClick={handleOpenUserModal} >
                        <FaRegAddressCard />
                        </IconButton>
                        {values.tieneProyecto === 'S' && (
                            <IconButton aria-label="delete" color="success" onClick={handleOpenModal}>
                            <AiOutlineUserAdd />
                            </IconButton>
                        )}
                    </CardActions>
                </CardUI>
                </Grid>
                </Grid>
            )}
            <br />
            {values.tipo > 0 && (
              <>
              <Grid container spacing={2}>
              {FormTypeHandle(values.tipo,'anio') && (
                <Grid item xs={12} sm={6} md={2} lg={2}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.anio && touched.anio)} >
                <InputLabel htmlFor="anio">{FormLabelHandle(values.tipo,'anio')}</InputLabel>
                <Field 
                    as={Select}
                    name="anio"
                    variant="outlined"                
                    value={values.anio}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    {anios.map((anio) => (
                        <MenuItem key={anio} value={anio}>
                        {anio}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='anio' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}
              {FormTypeHandle(values.tipo,'idunidad') && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.idunidad && touched.idunidad)} >
                <InputLabel htmlFor="idunidad">{FormLabelHandle(values.tipo,'idunidad')}</InputLabel>
                <Field 
                    as={Select}
                    name="idunidad"
                    variant="outlined"                
                    value={values.idunidad}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    <MenuItem key={'null-Unidad'} value={0}>
                        {'SELECCIONE UNIDAD'}                    
                    </MenuItem>
                    {unidades.map((unidad) => (
                        <MenuItem key={unidad.idunidad} value={unidad.idunidad}>
                        {unidad.nombreunidad}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='idunidad' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}              
              {FormTypeHandle(values.tipo,'nevento') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="nevento"
                        label={FormLabelHandle(values.tipo,'nevento')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.nevento}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.nevento && touched.nevento)}
                        helperText={<ErrorMessage name='nevento' />}                
                    />
                    </Grid>  
               )}
               {FormTypeHandle(values.tipo,'levento') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="levento"
                        label={FormLabelHandle(values.tipo,'levento')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.nevento}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.levento && touched.levento)}
                        helperText={<ErrorMessage name='levento' />}                
                    />
                    </Grid>  
               )}
               {FormTypeHandle(values.tipo,'marca') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="marca"
                        label={FormLabelHandle(values.tipo,'marca')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.marca}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.marca && touched.marca)}
                        helperText={<ErrorMessage name='marca' />}                
                    />
                    </Grid>  
               )}
               {FormTypeHandle(values.tipo,'modelo') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="modelo"
                        label={FormLabelHandle(values.tipo,'modelo')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.modelo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.modelo && touched.modelo)}
                        helperText={<ErrorMessage name='modelo' />}                
                    />
                    </Grid>  
               )}
               {FormTypeHandle(values.tipo,'serie') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="serie"
                        label={FormLabelHandle(values.tipo,'serie')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.serie}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.serie && touched.serie)}
                        helperText={<ErrorMessage name='serie' />}                
                    />
                    </Grid>  
               )}
               {FormTypeHandle(values.tipo,'invetario') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="invetario"
                        label={FormLabelHandle(values.tipo,'invetario')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.inventario}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.inventario && touched.inventario)}
                        helperText={<ErrorMessage name='inventario' />}                
                    />
                    </Grid>  
               )}
               {FormTypeHandle(values.tipo,'estado') && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.estado && touched.estado)} >
                <InputLabel htmlFor="estado">{FormLabelHandle(values.tipo,'estado')}</InputLabel>
                <Field 
                    as={Select}
                    name="estado"
                    variant="outlined"                
                    value={values.estado}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    <MenuItem key={'null-Estado'} value={0}>
                        {'SELECCIONE ESTADO'}                    
                    </MenuItem>
                    {estadoEquipo.map((estado) => (
                        <MenuItem key={estado.id} value={estado.id}>
                        {estado.label}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='estado' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}
              {FormTypeHandle(values.tipo,'frecuencia') && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.frecuencia && touched.frecuencia)} >
                <InputLabel htmlFor="frecuencia">{FormLabelHandle(values.tipo,'frecuencia')}</InputLabel>
                <Field 
                    as={Select}
                    name="frecuencia"
                    variant="outlined"                
                    value={values.frecuencia}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    <MenuItem key={'null-Frecuencia'} value={0}>
                        {'SELECCIONE FRECUENCIA'}                    
                    </MenuItem>
                    {frecuencia.map((estado) => (
                        <MenuItem key={estado.id} value={estado.id}>
                        {estado.label}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='frecuencia' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}              
               {FormTypeHandle(values.tipo,'tipolab') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="tipolab"
                        label={FormLabelHandle(values.tipo,'tipolab')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.tipolab}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.tipolab && touched.tipolab)}
                        helperText={<ErrorMessage name='tipolab' />}                
                    />
                    </Grid>  
               )}
              {FormTypeHandle(values.tipo,'url') && (
                    <Grid item xs={12} sm={6} md={4} lg={10}>
                    <Field 
                        as={TextField}
                        name="url"
                        label={FormLabelHandle(values.tipo,'url')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.url}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.url && touched.url)}
                        helperText={<ErrorMessage name='url' />}                
                    />
                    </Grid>  
               )}
              {FormTypeHandle(values.tipo,'doi') && (
                <Grid item xs={12} sm={6} md={4} lg={9}>
                <Field 
                    as={TextField}
                    name="doi"
                    label="DOI"
                    variant="outlined" 
                    sx={{ m: 1, width: '100%' }}                
                    type="text" 
                    values={values.doi}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.doi && touched.doi)}
                    helperText={<ErrorMessage name='doi' />}                
                />
                </Grid> 
                )}                           
              {FormTypeHandle(values.tipo,'fechapublicacion') && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                <Field 
                    as={TextField}
                    name="fechapublicacion"
                    label={FormLabelHandle(values.tipo,'fechapublicacion')}
                    variant="outlined" 
                    sx={{ m: 1, minWidth: '100%' }}                
                    type="date" 
                    values={values.fechapublicacion}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.fechapublicacion && touched.fechapublicacion)}
                    helperText={<ErrorMessage className='errorMessage' name='fechapublicacion' />}                
                />
                </Grid>
                )}     
                {FormTypeHandle(values.tipo,'fevento') && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                <Field 
                    as={TextField}
                    name="fevento"
                    label={FormLabelHandle(values.tipo,'fevento')}
                    variant="outlined" 
                    sx={{ m: 1, minWidth: '100%' }}                
                    type="date" 
                    values={values.fevento}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(errors.fevento && touched.fevento)}
                    helperText={<ErrorMessage className='errorMessage' name='fevento' />}                
                />
                </Grid>
                )}              
              {FormTypeHandle(values.tipo,'bdrevista') && (
                <Grid item xs={12} sm={6} md={4} lg={6}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.bdrevista && touched.bdrevista)} >
                    <InputLabel htmlFor="bdrevista">Tipo de Indexación</InputLabel>
                    <Field 
                        as={Select}
                        name="bdrevista"
                        variant="outlined"                
                        value={values.bdrevista}
                        onChange={handleChange}
                        onBlur={handleBlur}               
                    >
                        {ListIndexHandle(listIndex,values.tipo).map((opt) => (
                            <MenuItem key={opt.catagPadre+'-'+opt.codigo} value={opt.codigo}>
                            {opt.descripcion}                    
                            </MenuItem>
                        ))}
                        <MenuItem key='zero-bdrevista' value={0}>
                            {'Ninguno'}                    
                        </MenuItem>
                    </Field>
                    <ErrorMessage name='bdrevista' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
                )}
              {FormTypeHandle(values.tipo,'nombreRevista') && (
                    <Grid item xs={12} sm={6} md={4} lg={6}>
                    <Field 
                        as={TextField}
                        name="nombreRevista"
                        label={FormLabelHandle(values.tipo,'nombreRevista')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.nombreRevista}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.nombreRevista && touched.nombreRevista)}
                        helperText={<ErrorMessage name='nombreRevista' />}                
                    />
                    </Grid>  
                )}
              {FormTypeHandle(values.tipo,'codISSN') && (
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Field 
                        as={TextField}
                        name="codISSN"
                        label={FormLabelHandle(values.tipo,'codISSN')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.codISSN}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.codISSN && touched.codISSN)}
                        helperText={<ErrorMessage name='codISSN' />}                
                    />
                    </Grid>
               )}               
              {FormTypeHandle(values.tipo,'revisionpares') && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.revisionpares && touched.revisionpares)} >
                <InputLabel htmlFor="revisionpares">Tiene revisión por pares</InputLabel>
                <Field 
                    as={Select}
                    name="revisionpares"
                    variant="outlined"                
                    value={values.revisionpares}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    {desicion.map((q) => (
                        <MenuItem key={q.value} value={q.value}>
                        {q.label}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='revisionpares' className='errorMessage' component="div" />
                </FormControl>
                </Grid> 
               )}                         
              {FormTypeHandle(values.tipo,'urlRevista') && (
                    <Grid item xs={12} sm={6} md={4} lg={6}>
                    <Field 
                        as={TextField}
                        name="urlRevista"
                        label="Url de Revista/ Memoria de Evento"
                        variant="outlined" 
                        sx={{ m: 1, minWidth: '100%' }}                
                        type="text" 
                        values={values.urlRevista}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.urlRevista && touched.urlRevista)}
                        helperText={<ErrorMessage name='urlRevista' />}                
                    />
                    </Grid>
               )}               
              {FormTypeHandle(values.tipo,'impactoIndex') && (
                   <Grid item xs={12} sm={6} md={4} lg={2}>
                   <Field 
                        as={TextField}
                        name="impactoIndex"
                        label="Factor de Impacto de indexación"
                        variant="outlined" 
                        sx={{ m: 1, minWidth: '100%' }}                
                        type="text" 
                        values={values.impactoIndex}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.impactoIndex && touched.impactoIndex)}
                        helperText={<ErrorMessage name='impactoIndex' />}                
                    />
                    </Grid>
               )}           
              {FormTypeHandle(values.tipo,'impactoSJR') && (
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Field 
                        as={TextField}
                        name="impactoSJR"
                        label="Factor de Impacto SJR"
                        variant="outlined" 
                        sx={{ m: 1, minWidth: '100%' }}                
                        type="text" 
                        values={values.impactoSJR}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.impactoSJR && touched.impactoSJR)}
                        helperText={<ErrorMessage name='impactoSJR' />}                
                    />
                    </Grid> 
               )}                             
              {FormTypeHandle(values.tipo,'cuartil') && (
                <Grid item xs={12} sm={6} md={4} lg={2}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.cuartil && touched.cuartil)} >
                <InputLabel htmlFor="cuartil">Cuartil</InputLabel>
                <Field 
                    as={Select}
                    name="cuartil"
                    variant="outlined"                
                    value={values.cuartil}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    {quartil.map((q) => (
                        <MenuItem key={q.value} value={q.value}>
                        {q.label}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='cuartil' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
               )}               
              {FormTypeHandle(values.tipo,'volumen') && (
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Field 
                        as={TextField}
                        name="volumen"
                        label="Volumen"
                        variant="outlined" 
                        sx={{ m: 1, minWidth: '100%' }}                
                        type="text" 
                        values={values.volumen}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.volumen && touched.volumen)}
                        helperText={<ErrorMessage name='volumen' />}                
                    />
                    </Grid>
               )} 
              {FormTypeHandle(values.tipo,'paginas') && (
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Field 
                        as={TextField}
                        name="paginas"
                        label="Paginas"
                        variant="outlined" 
                        sx={{ m: 1, minWidth: '100%' }}                
                        type="text" 
                        values={values.paginas}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.paginas && touched.paginas)}
                        helperText={<ErrorMessage name='paginas' />}                
                    />
                    </Grid> 
               )}
               {FormTypeHandle(values.tipo,'editorial') && (
                    <Grid item xs={12} sm={12} md={9} lg={6}>
                    <Field 
                        as={TextField}
                        name="editorial"
                        label={FormLabelHandle(values.tipo,'editorial')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.editorial}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.editorial && touched.editorial)}
                        helperText={<ErrorMessage name='editorial' />}                
                    />
                    </Grid>
               )}                             
              {FormTypeHandle(values.tipo,'palabrasClave') && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Field 
                        as={TextField}
                        name="palabrasClave"
                        label={FormLabelHandle(values.tipo,'palabrasClave')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.palabrasClave}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.palabrasClave && touched.palabrasClave)}
                        helperText={<ErrorMessage name='palabrasClave' />}                
                    />
                    </Grid>
               )}
              {FormTypeHandle(values.tipo,'isindex') && ( 
                <Grid item xs={12} sm={12} md={12} lg={3}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.isindex && touched.isindex)} >
                <InputLabel htmlFor="isindex">{FormLabelHandle(values.tipo,'isindex')}</InputLabel>
                <Field 
                    as={Select}
                    name="isindex"
                    variant="outlined"                
                    value={values.isindex}
                    onChange={handleChange}
                    onBlur={handleBlur}               
                >
                    <MenuItem key={'null-isindex'} value={0}>
                        {'SELECCIONE '}                    
                    </MenuItem>
                    {desicion.map((d) => (
                        <MenuItem key={d.value} value={d.value}>
                        {d.label}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='isindex' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
               )}
               {FormTypeHandle(values.tipo,'codigoproducto') && (                
                    <Grid item xs={12} sm={12} md={12} lg={3}>
                    <Field 
                        as={TextField}
                        name="codigoproducto"
                        label={FormLabelHandle(values.tipo,'codigoproducto')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%'}}                
                        type="text"
                        values={values.codigoproducto}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.codigoproducto && touched.codigoproducto)}
                        helperText={<ErrorMessage name='codigoproducto' />}                
                    />
                    </Grid>
                )}
                {FormTypeHandle(values.tipo,'asistObjetiv') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="asistObjetiv"
                        label={FormLabelHandle(values.tipo,'asistObjetiv')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        multiline 
                        rows={3}
                        values={values.asistObjetiv}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.asistObjetiv && touched.asistObjetiv)}
                        helperText={<ErrorMessage name='asistObjetiv' />}                
                    />
                    </Grid>  
               )} 
               {FormTypeHandle(values.tipo,'innovaVerific') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="innovaVerific"
                        label={FormLabelHandle(values.tipo,'innovaVerific')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        multiline 
                        rows={3}
                        values={values.innovaVerific}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.innovaVerific && touched.innovaVerific)}
                        helperText={<ErrorMessage name='innovaVerific' />}                
                    />
                    </Grid>  
               )} 
               {FormTypeHandle(values.tipo,'logrosSistemac') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="logrosSistemac"
                        label={FormLabelHandle(values.tipo,'logrosSistemac')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        multiline 
                        rows={3}
                        values={values.logrosSistemac}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.logrosSistemac && touched.logrosSistemac)}
                        helperText={<ErrorMessage name='logrosSistemac' />}                
                    />
                    </Grid>  
               )} 
               {FormTypeHandle(values.tipo,'retosComunic') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="retosComunic"
                        label={FormLabelHandle(values.tipo,'retosComunic')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        multiline 
                        rows={3}
                        values={values.retosComunic}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.retosComunic && touched.retosComunic)}
                        helperText={<ErrorMessage name='retosComunic' />}                
                    />
                    </Grid>  
               )} 
               {FormTypeHandle(values.tipo,'especificacion') && (                
                    <Grid item xs={12} sm={12} md={12} lg={9}>
                    <Field 
                        as={TextField}
                        name="especificacion"
                        label={FormLabelHandle(values.tipo,'especificacion')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%'}}                
                        type="text"
                        multiline 
                        rows={3}
                        values={values.especificacion}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.especificacion && touched.especificacion)}
                        helperText={<ErrorMessage name='especificacion' />}                
                    />
                    </Grid>
                )}           
              {FormTypeHandle(values.tipo,'resumen') && (                
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Field 
                        as={TextField}
                        name="resumen"
                        label={FormLabelHandle(values.tipo,'resumen')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%'}}                
                        type="text"
                        multiline 
                        rows={3}
                        values={values.resumen}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.resumen && touched.resumen)}
                        helperText={<ErrorMessage name='resumen' />}                
                    />
                    </Grid>
                )} 
              </Grid>
              <Grid container spacing={2}>
              {FormTypeHandle(values.tipo,'codarea') && (
                <Grid item xs={12} sm={6} md={4} lg={4}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.codarea && touched.codarea)} >
                <InputLabel htmlFor="codarea">{FormLabelHandle(values.tipo,'codarea')}</InputLabel>
                <Field 
                    as={Select}
                    name="codarea"
                    variant="outlined"                
                    value={values.codarea}
                    onChange={async (e: ChangeEvent<{ name?: string; value: number }>) => {
                        const selectedValue = e.target.value;
                        // Llama a tu función externa para obtener datos de la API
                          try {
                              const apiData = await setListSubaArea(selectedValue);              
                              handleChange(e);
                          } catch (error) {
                              // Maneja el error aquí si es necesario
                          }
                      }}
                    onBlur={handleBlur}              
                >
                    <MenuItem key={'null-codarea'} value={0}>
                        {'NINGUNO'}                    
                    </MenuItem>
                    {areasCine.map((ods) => (
                        <MenuItem 
                         key={ods.codigo} 
                         value={ods.codigo}
                        >
                        {ods.descripcion}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='codarea' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}
              {FormTypeHandle(values.tipo,'codsubarea') && (
                <Grid item xs={12} sm={6} md={4} lg={4}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.codsubarea && touched.codsubarea)} >
                <InputLabel htmlFor="codsubarea">{FormLabelHandle(values.tipo,'codsubarea')}</InputLabel>
                <Field 
                    as={Select}
                    name="codsubarea"
                    variant="outlined"                
                    value={values.codsubarea}
                    onChange={async (e: ChangeEvent<{ name?: string; value: number }>) => {
                        const selectedValue = e.target.value;
                        // Llama a tu función externa para obtener datos de la API
                          try {
                              const apiData = await setListSubaAreaDet(selectedValue);              
                              handleChange(e);
                          } catch (error) {
                              // Maneja el error aquí si es necesario
                          }
                      }}
                    onBlur={handleBlur}              
                >
                    <MenuItem key={'null-codsubarea'} value={0}>
                        {'NINGUNO'}                    
                    </MenuItem>
                    {subAreasCine.map((ods) => (
                        <MenuItem 
                         key={ods.codigo} 
                         value={ods.codigo}
                        >
                        {ods.descripcion}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='codsubarea' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}
              {FormTypeHandle(values.tipo,'codsubareadetallada') && (
                <Grid item xs={12} sm={6} md={4} lg={4}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.codsubareadetallada && touched.codsubareadetallada)} >
                <InputLabel htmlFor="codsubareadetallada">{FormLabelHandle(values.tipo,'codsubareadetallada')}</InputLabel>
                <Field 
                    as={Select}
                    name="codsubareadetallada"
                    variant="outlined"                
                    value={values.codsubareadetallada}
                    onChange={handleChange}
                    onBlur={handleBlur}              
                >
                    <MenuItem key={'null-codsubareadetallada'} value={0}>
                        {'NINGUNO'}                    
                    </MenuItem>
                    {subAreasCineDet.map((ods) => (
                        <MenuItem 
                         key={ods.codigo} 
                         value={ods.codigo}
                        >
                        {ods.descripcion}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='codsubareadetallada' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}
              {FormTypeHandle(values.tipo,'iddecinvareaconocimiento') && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.iddecinvareaconocimiento && touched.iddecinvareaconocimiento)} >
                <InputLabel htmlFor="iddecinvareaconocimiento">{FormLabelHandle(values.tipo,'iddecinvareaconocimiento')}</InputLabel>
                <Field 
                    as={Select}
                    name="iddecinvareaconocimiento"
                    variant="outlined"                
                    value={values.iddecinvareaconocimiento}
                    onChange={handleChange}
                    onBlur={handleBlur}              
                >
                    <MenuItem key={'null-ODS'} value={0}>
                        {'SELECCIONE ÁREA'}                    
                    </MenuItem>
                    {areasLineasInvestigacion.map((area) => (
                        <MenuItem 
                         key={area.codigo} 
                         value={area.codigo}
                        >
                        {area.descripcion}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='iddecinvareaconocimiento' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
              )}
               {FormTypeHandle(values.tipo,'lineainvestigacion') && (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field 
                        as={TextField}
                        name="lineainvestigacion"
                        label={FormLabelHandle(values.tipo,'lineainvestigacion')}
                        variant="outlined" 
                        sx={{ m: 1, width: '100%' }}                
                        type="text" 
                        values={values.lineainvestigacion}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.lineainvestigacion && touched.lineainvestigacion)}
                        helperText={<ErrorMessage name='lineainvestigacion' />}                
                    />
                    </Grid>  
                 )}
               {FormTypeHandle(values.tipo,'iddecinvobjods') && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.iddecinvobjods && touched.iddecinvobjods)} >
                <InputLabel htmlFor="iddecinvobjods">{FormLabelHandle(values.tipo,'iddecinvobjods')}</InputLabel>
                <Field 
                    as={Select}
                    name="iddecinvobjods"
                    variant="outlined"                
                    value={values.iddecinvobjods}
                    onChange={handleChange}
                    onBlur={handleBlur}              
                >
                    <MenuItem key={'null-ODS'} value={0}>
                        {'SELECCIONE ODS'}                    
                    </MenuItem>
                    {listODS.map((ods) => (
                        <MenuItem 
                         key={ods.codigo} 
                         value={ods.codigo}
                        >
                        {ods.descripcion}                    
                        </MenuItem>
                    ))}
                </Field>
                <ErrorMessage name='iddecinvobjods' className='errorMessage' component="div" />
                </FormControl>
                </Grid>
                )}  
              </Grid>
              {false && (
                <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                <CardUI>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                         Archivos Adjuntos
                      </Typography>
                      {FormTypeHandle(values.tipo, 'adjunto')&&
                      (<Grid item xs={12} sm={12} md={12} lg={9}>
                        <InputLabel htmlFor="adjunto">{FormLabelHandle(values.tipo,'adjunto')}</InputLabel>
                          <input
                              type="file"
                              id="adjunto"
                              name="adjunto"
                              onChange={async (event) => {
                                  if(event.currentTarget.files&& event.currentTarget.files[0] ){
                                      var files= values.adjuntos??[]; 
                                      files[0]= await setFileModelWithName( event.currentTarget.files[0], 'adjunto');
                                      setFieldValue('adjuntos', files);
                                  }
                              }}
                          />
                        </Grid> )
                      }
                      

                     {FormTypeHandle(values.tipo,'adjunto2')&&( <Grid item xs={12} sm={12} md={12} lg={9}>
                      <InputLabel htmlFor="adjunto2">{FormLabelHandle(values.tipo,'adjunto2')}</InputLabel>
                        <input
                            type="file"
                            id="adjunto2"
                            name="adjunto2"
                            onChange={async (event) => {
                                if(event.currentTarget.files&& event.currentTarget.files[0] ){
                                    var files= values.adjuntos??[]; 
                                    files[1]= await setFileModelWithName( event.currentTarget.files[0], 'adjunto2');
                                    setFieldValue('adjuntos', files);
                                }
                            }}
                        />
                      </Grid>)}
                      {FormTypeHandle(values.tipo,'adjunto3') && (<Grid item xs={12} sm={12} md={12} lg={9}>
                      <InputLabel htmlFor="adjunto3">{FormLabelHandle(values.tipo,'adjunto3')}</InputLabel>
                        <input
                            type="file"
                            id="adjunto3"
                            name="adjunto3"
                            onChange={async (event) => {
                                if(event.currentTarget.files&& event.currentTarget.files[0] ){
                                    var files= values.adjuntos??[]; 
                                    files[2]= await setFileModelWithName( event.currentTarget.files[0], 'adjunto3');
                                    setFieldValue('adjuntos', files);
                                }
                            }}
                        />
                      </Grid>)}
                     {FormTypeHandle(values.tipo, 'adjunto4')&&( <Grid item xs={12} sm={12} md={12} lg={9}>
                      <InputLabel htmlFor="adjunto4">{FormLabelHandle(values.tipo,'adjunto4')}</InputLabel>
                        <input
                            type="file"
                            id="adjunto4"
                            name="adjunto4"
                            onChange={async (event) => {
                                if(event.currentTarget.files&& event.currentTarget.files[0] ){
                                    var files= values.adjuntos??[]; 
                                    files[3]= await setFileModelWithName( event.currentTarget.files[0], 'adjunto4');
                                    setFieldValue('adjuntos', files);
                                }
                            }}
                        />
                      </Grid>)}
                    {FormTypeHandle(values.tipo, 'adjunto5')&&(  <Grid item xs={12} sm={12} md={12} lg={9}>
                      <InputLabel htmlFor="adjunto5">{FormLabelHandle(values.tipo,'adjunto5')}</InputLabel>
                        <input
                            type="file"
                            id="adjunto5"
                            name="adjunto5"
                            onChange={async (event) => {
                                if(event.currentTarget.files&& event.currentTarget.files[0] ){
                                    var files= values.adjuntos??[]; 
                                    files[4]= await setFileModelWithName( event.currentTarget.files[0], 'adjunto5');
                                    setFieldValue('adjuntos', files);
                                }
                            }}
                        />
                      </Grid>)}
                    </CardContent>
                </CardUI>
                </Grid>
                </Grid>
            )}
            <br />               
             </>
            )}
            <br />            
            <Box sx={{'& .MuiTextField-root': { m: 1 }, }}>
            <Grid className='siempre' container spacing={2}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                <Button 
                  color="error"
                  variant="contained"      
                  onClick={() => goToNavigation('/Producto/MisProductos')}                               
                  endIcon={<MdAssignmentReturn />} >
                  Regresar
                </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                <Button 
                  type='submit'
                  //disabled={!isValid} 
                  variant="contained"                                     
                  endIcon={<RiSave3Fill />} >
                  Guardar
                </Button>
                </Grid>                
                <Grid item xs={12} sm={12} md={4} lg={4}>
                </Grid> 
            </Grid> 
            </Box>
            <ModalStrap isOpen={open} toggle={toggleOpen} className="custom-modal">
            <ModalHeader toggle={toggleOpen}>
                <Typography id="modal-modal-title" >Colaboradores Proyectos</Typography>
            </ModalHeader>
                <ModalBody>
                    <Table>
                        <TableHead>
                            <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Cedula</TableCell>
                            <TableCell>Apellidos y Nombres</TableCell>
                            <TableCell>Institucion</TableCell>
                            <TableCell>Correo</TableCell>
                            <TableCell>Accion</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {colaboradorProyecto.map((colaborador,index) => (
                            <TableRow key={'colProy-'+index}>
                                <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                <TableCell>
                                {colaborador.cedula}
                                </TableCell>
                                <TableCell>
                                {colaborador.nombre}
                                </TableCell>
                                <TableCell>
                                {colaborador.institucion}
                                </TableCell>
                                <TableCell>
                                {colaborador.email}
                                </TableCell>
                                <TableCell>
                                <IconButton aria-label="add" color="info" onClick={() => handleAddRowColaborador(values,colaborador, setFieldValue)} >
                                  <AiOutlinePlusCircle />
                                </IconButton>
                                </TableCell>
                            </TableRow>
                            ))}                    
                        </TableBody>
                    </Table>
                </ModalBody>
            </ModalStrap>
            <ModalStrap isOpen={userModal} toggle={toggleModal} className="custom-modal">
            <ModalHeader toggle={toggleModal}>
                <Typography id="modal-modal-title" >Busqueda Usuario</Typography>
            </ModalHeader>
                <ModalBody>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={tap === 0 ? 'active' : ''} style={tabStyle}
                        onClick={() => setTap(0)}
                        >
                        Email
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={tap === 1 ? 'active' : ''} style={tabStyle}
                        onClick={() => setTap(1)}
                        >
                        Apellidos
                        </NavLink>
                    </NavItem>
                </Nav>                
                <TabContent activeTab={tap}>
                    <TabPane tabId={0}>
                    <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={9} lg={9}>
                    <TextField
                            id='busq-email'
                            type="email"
                            name='mailBusqueda'
                            label="Email"
                            sx={{ m: 1, width: '100%' }}                            
                            size="small"
                            value={mailBusqueda}
                            onChange={handleEmailBusquedaChange}
                            onBlur={handleEmailBlur}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => {setListBusqueda('N',mailBusqueda)}}>Buscar</Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {loadingModal ? 
                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                            <CircularProgress color="success" />
                        </Stack> : 
                        <Table>
                                <TableHead>
                                    <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Cedula</TableCell>
                                    <TableCell>Apellidos y Nombres</TableCell>
                                    <TableCell>Correo</TableCell>
                                    <TableCell>Accion</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {busquedaUsuario.map((colaborador,index) => (
                                    <TableRow key={'colProy-'+index}>
                                        <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                        <TableCell>
                                        {colaborador.cedula}
                                        </TableCell>
                                        <TableCell>
                                        {colaborador.nombre}
                                        </TableCell>
                                        <TableCell>
                                        {colaborador.email}
                                        </TableCell>
                                        <TableCell>
                                        <IconButton aria-label="add" color="info" onClick={() => handleAddRowColaborador(values,colaborador, setFieldValue)} >
                                        <AiOutlinePlusCircle />
                                        </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    ))} 
                                    {busquedaUsuario.length == 0 ?
                                    <TableRow key={'colProy-o'}>
                                    <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>Sin resultados</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>  
                                    </TableRow> : <></>
                                    }                     
                                </TableBody>
                        </Table>
                        }
                    </Grid>
                    </Grid>                     
                    </TabPane>
                    <TabPane tabId={1}>
                    <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={9} lg={9}>
                    <TextField
                            id='busq-apellidos'
                            label="Apellidos"
                            sx={{ m: 1, width: '100%' }}
                            size="small"
                            value={apellidosBusqueda}
                            onChange={handleApellidosBusquedaChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => {setListBusqueda(apellidosBusqueda,'N')}}>Buscar</Button> 
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                       {loadingModal ? 
                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                            <CircularProgress color="success" />
                        </Stack> :  
                        <Table>
                                <TableHead>
                                    <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Cedula</TableCell>
                                    <TableCell>Apellidos y Nombres</TableCell>
                                    <TableCell>Correo</TableCell>
                                    <TableCell>Accion</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {busquedaUsuario.map((colaborador,index) => (
                                    <TableRow key={'colProy-'+index}>
                                        <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                        <TableCell>
                                        {colaborador.cedula}
                                        </TableCell>
                                        <TableCell>
                                        {colaborador.nombre}
                                        </TableCell>
                                        <TableCell>
                                        {colaborador.email}
                                        </TableCell>
                                        <TableCell>
                                        <IconButton aria-label="add" color="info" onClick={() => handleAddRowColaborador(values,colaborador, setFieldValue)} >
                                        <AiOutlinePlusCircle />
                                        </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    ))} 
                                    {busquedaUsuario.length == 0 ?
                                    <TableRow key={'colProy-o'}>
                                    <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>Sin resultados</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>  
                                    </TableRow> : <></>
                                    }                     
                                </TableBody>
                        </Table>
                       }
                    </Grid>
                    </Grid>                    
                    </TabPane>
                </TabContent>
                </ModalBody>
            </ModalStrap>              
           </Form>
           )}           
        </Formik>
        </CardBody> 
        </Card>              
        </div>
    );
  }
